import { storageKeys } from '@/constants/storage';

import { createPaymentReturnStorage } from './paymentReturnStorage';
import type { StorageAdapter } from './paymentReturnStorage';

export type CashAppGiftCardPendingParams = {
  cartId: string;
  shopId: string;
  amountCents: number;
  currency: string;
  clientSecret: string;
  customer: {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    preferredLanguage: string;
  };
  createdAt: number;
};

function isCashAppGiftCardPendingParams(
  data: unknown,
): data is CashAppGiftCardPendingParams {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  const customer = obj.customer as Record<string, unknown> | undefined;
  return (
    typeof obj.cartId === 'string' &&
    typeof obj.shopId === 'string' &&
    typeof obj.amountCents === 'number' &&
    typeof obj.currency === 'string' &&
    typeof obj.clientSecret === 'string' &&
    typeof obj.createdAt === 'number' &&
    typeof customer === 'object' &&
    customer !== null &&
    typeof customer.email === 'string' &&
    typeof customer.firstName === 'string' &&
    typeof customer.lastName === 'string' &&
    typeof customer.phone === 'string' &&
    typeof customer.preferredLanguage === 'string'
  );
}

const localStorageAdapter: StorageAdapter = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};

const cashAppGiftCardStorage = createPaymentReturnStorage(
  storageKeys.cashAppGiftCardPending,
  isCashAppGiftCardPendingParams,
  localStorageAdapter,
);

export const getCashAppGiftCardPaymentFromSession = cashAppGiftCardStorage.get;
export const saveCashAppGiftCardPaymentToSession = cashAppGiftCardStorage.set;
export const clearCashAppGiftCardPaymentFromSession =
  cashAppGiftCardStorage.clear;
